
import { ICreateLeadProtocol } from '@/domain/application/protocols/leads/ICreateLeadProtocol'
import { IEmailQueue } from '@/domain/application/queues/IEmailQueue'
import { ILeadsRepository } from '@/domain/application/repositories/ILeadsRepository'
import { IOriginsRepository } from '@/domain/application/repositories/IOriginsRepository'
import { IEmailSender } from '@/domain/application/sender/IEmailSender'
import { CreateLeadUseCase } from '@/domain/application/useCases/leads/createLead'
import { prismaService } from '@/infra/database/prisma'
import { PrismaLeadsRepository } from '@/infra/database/prisma/repositories/prismaLeadsRepository'
import { PrismaOriginsRepository } from '@/infra/database/prisma/repositories/prismaOriginsRepository'
import { BullMqEmailQueue } from '@/infra/queues/bullMqEmailQueue'
import { NodemailerKioskEmailSender } from '@/infra/sender/emails/nodemailerKioskEmailSender'
import { NodemailerTruckEmailSender } from '@/infra/sender/emails/nodemailerTruckEmailSender'
import { Request, Response } from 'express'
import { z, ZodError } from 'zod'

const createLeadBodySchema = z.object({
  name: z.string().min(1).max(200),
  email: z.string().email().min(1).max(200),
  phone: z.string().min(11).max(11),
  originName: z.string().min(1).max(200),
})

export class CreateLeadController {
  private repository: ILeadsRepository = new PrismaLeadsRepository(prismaService)
  private originsRepository: IOriginsRepository = new PrismaOriginsRepository(prismaService)
  private emailQueue: IEmailQueue = new BullMqEmailQueue()
  private useCase: ICreateLeadProtocol = new CreateLeadUseCase(
    this.originsRepository,
    this.repository,
    this.emailQueue,
  )

  async handle(request: Request, response: Response) {
    try {
      const { email, name, phone, originName } = createLeadBodySchema.parse(request.body)
      await this.useCase.execute({ email, name, phone, originName })
      return response.status(201).send()
    } catch (error) {
      if(error instanceof Error) {
        if (error.message === 'Origin is disabled.') {
          return response.status(400).json({
            error,
            message: 'Origem do cadastro informado está desativado.',
          }).send()
        }
        if (error.message === 'Phone is not valid.') {
          return response.status(400).json({
            error,
            message: 'Número de telefone informado não é válido.',
          }).send()
        }
        if (error.message === 'Lead already exists.') {
          return response.status(409).json({
            error,
            message: 'Usuário já cadastrado.',
          }).send()
        }
        if (error.message === 'Email is not valid.') {
          return response.status(400).json({
            error,
            message: 'Email informado não está no formato válido.',
          }).send()
        }
        if (error.message === 'Origin not found.') {
          return response.status(404).json({
            error,
            message: 'Origem do cadastro informado não encontrado.',
          }).send()
        }
        if (error instanceof ZodError) {           
          return response.status(400).json({
            message: error.issues[0].path.toString() === 'phone' ? 'Telefone no formato inválido' 
            : error.issues[0].path.toString() === 'name' ? 'Nome no formato inválido' 
            : error.issues[0].path.toString() === 'email' ? 'E-mail no formato inválido' 
            : error.issues[0].path.toString() === 'originName' ? 'Nome da praça no formato inválido'
            : 'Erro na validação dos dados',
            error: error.flatten().fieldErrors
          }).send()
        }
        return response.status(400).json({
          message: error.message,
        }).send()
      }

      return response.status(500).json({
        message: 'Internal server error.'
      }).send()
    }
  }
}